import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JobApplicationComponent } from './job-application.component';
import { JobApplicationLoginModalComponent } from './job-application-login-modal/job-application-login-modal.component';
import { JobApplicationModalComponent } from './job-application-modal/job-application-modal.component';
import { JobApplicationProfileModalComponent } from './job-application-profile-modal/job-application-profile-modal.component';
import { JobApplicationVerifiedModalComponent } from './job-application-verified-modal/job-application-verified-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelect2Module } from 'ng-select2';
import { RouterModule } from '@angular/router';
import { FormGroupModule } from '../form-group/form-group.module';
import { FormEmployeeReferenceModule } from '../form-employee-reference/form-employee-reference.module';

@NgModule({
  declarations: [
    JobApplicationLoginModalComponent,
    JobApplicationModalComponent,
    JobApplicationProfileModalComponent,
    JobApplicationVerifiedModalComponent,
    JobApplicationComponent
  ],
  imports: [
    FormEmployeeReferenceModule,
    RouterModule,
    NgSelect2Module,
    FormsModule,
    ReactiveFormsModule,
    FormGroupModule,
    CommonModule,
  ],
  exports: [JobApplicationComponent]
})
export class JobApplicationModule { }
